import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { InsightsProvider } from '../context/InsightsContext';
import InsightsHero from './InsightsHero';
import InsightsPaginatedCards from './InsightsPaginatedCards';
import InsightsPaginatedFilterBar from './InsightsPaginatedFilterBar';

export default function InsightsPaginated({ id, data }) {
  const items = useStaticQuery(graphql`
    query {
      umbraco {
        allInsight(orderBy: articleDate_DESC) {
          items {
            title
            tags
            cardType
            url
            filters
            articleDate
            industries
            imageOverlay
            relatedEventSectors
            featuredImage {
              url
            }
          }
        }
      }
    }
  `);

  const byIndustry = ['By Industry', ...data.industryOptions];

  useEffect(() => {
    document.body.classList.add('insights-page');
    return () => {
      document.body.classList.remove('insights-page');
    };
  }, []);

  return (
    <InsightsProvider id={id}>
      <InsightsHero data={data} />
      <InsightsPaginatedFilterBar industryOptions={byIndustry} filterOptions={data.filterOptions} />
      <InsightsPaginatedCards data={items.umbraco.allInsight.items} />
    </InsightsProvider>
  );
}
